import script from "./AdminHealthSafetyManageFormTextView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHealthSafetyManageFormTextView.vue?vue&type=script&setup=true&lang=js"

import "./AdminHealthSafetyManageFormTextView.vue?vue&type=style&index=0&id=80726bfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80726bfa"]])

export default __exports__